export default __webpack_public_path__ + "static/media/error.85ead38b.svg";